module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaCAYAAADbhS54AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATZJREFUeNpiZJ73lJmBgSEXiO2B+CYQdwLxewYI6AdiRQb6g5MsQKIbiAuRBO2A2ArKdgRi/QFwGAMTEMejiVkCsRrDAAOQw75gEf86GBzWgCY2C4ifDrTDQGlsPhBfgaar20C8HUkelP5EB8BddxmBuXJAQ+ZPohTOqByUYNRh5CR+EAgCYlsgvgXEc4H4F1S8FIilaeqA+c+wCV8GOawCiNuRBD2B2A/Kjh6gkn8jKCoL0AR9B6h+HDqJfwKa2GYgvj8YEn8HNNEjJ34YWArEBwbAXZdHS/7Rkp9eJb8etEl9HYj3IslH07rZg6PkvwtyWCwQL0AKvSnQzgmsShqwkr8JLUpzgFhyMKQxfizifIPBYYvRxE5BC9oBT/zFQPwEiB2gDmoB4v9Q+f1A/GAgOrwAAQYAv1U6gHohrkkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/quiz-start.png
// module id = 1527
// module chunks = 0